export default "__VITE_ASSET__D1SOGPC4__"